export default __webpack_public_path__ + "static/media/1619432259405.91a6f656.png";